import Cookies from 'universal-cookie';

// La sociedad elegida se recuerda por usuario: en un mismo navegador pueden entrar varias personas.
const keyFor = (): string => {
  try {
    const userId = new Cookies().get('101Obex')?.user?.id;
    return `albatross_active_company_${userId ?? 'anon'}`;
  } catch {
    return 'albatross_active_company_anon';
  }
};

export const readSavedCompanyId = (): string | null => {
  try {
    return localStorage.getItem(keyFor());
  } catch {
    return null;
  }
};

export const saveCompanyId = (id: string | null) => {
  try {
    if (id) localStorage.setItem(keyFor(), id);
  } catch {
    // sin localStorage: la elección dura lo que dure la sesión
  }
};
